import React from 'react';




const Creteria = () => {
  return (
    <>
    <div id="rec477718616" class="r t-rec t-rec_pt_120 t-rec_pb_60"
    style={{ backgroundColor: '##d9d2d2', paddingTop: '120px', paddingBottom: '60px' }}
    data-record-type="60"
    data-bg-color="#d9d2d2"> 
    <div class="t050 flex">
        <div class="t-container t-align_left">
            <div class="t-col t-col_8 t-prefix_2">
                <div class="t050__uptitle t-uptitle t-uptitle_sm" field="subtitle">МЕЖДУНАРОДНАЯ ПРЕМИЯ «ГЛОБАЛЬНЫЙ ПРОРЫВ»</div>
                <div class="t050__title t-title t-title_xxl" field="title">Критерии оценки по номинациям</div>
            </div>
        </div>
    </div>
</div>
        <div id="rec477720443" class="r t-rec t-rec_pt_0 t-rec_pb_0"
        style={{ backgroundColor: '##d9d2d2', paddingTop: '0px', paddingBottom: '0px' }} data-record-type="128"
        data-bg-color="#d9d2d2"> 
        <div class="t120 flex">
            <div class="t-container t-align_left">


                <div class="t-col t-col_8 t-prefix_2">
                    <div class="t120__title t-heading t-heading_sm" field="title">Международные достижения</div>
                </div>


                <div class="t-col t-col_8 t-prefix_2"> 
                  <div field="text" class="t-text t-text_md ">
                 <strong> — Масштаб международного охвата</strong> – количество стран, в которых представлен проект, и степень его интеграции в международные рынки.
                  <br />
                  <strong> — Влияние на отрасль</strong> – вклад в развитие международной отрасли, рост узнаваемости компании за рубежом и улучшение деловой репутации страны.
                  <br />
                  <strong> — Финансовая стабильность и результативность</strong> – объем инвестиций и прибыли, полученных от международных операций, устойчивость к внешним рынкам.
                  <br />
                  <strong> — Партнерства и сотрудничество</strong> – наличие успешных международных партнерств, союзов или проектов с зарубежными организациями.
                  <br />
                  <strong> — Инновации в адаптации и управлении</strong> – использование уникальных решений для успешной адаптации продукции или услуг к международным стандартам и потребностям.
                  </div> 
                </div>

                <div class="t-col t-col_8 t-prefix_2">
                    <div class="t120__title t-heading t-heading_sm" field="title">Финансы и инвестиции</div>
                </div>


                <div class="t-col t-col_8 t-prefix_2"> 
                  <div field="text" class="t-text t-text_md ">
                 <strong> — Устойчивый рост и прибыльность</strong> – стабильное улучшение финансовых показателей компании, высокая рентабельность и эффективное управление капиталом.
                  <br />
                  <strong> — Инновационные решения</strong> – внедрение новых технологий в управление финансами, развитие цифровых финансовых сервисов и продуктов.
                  <br />
                  <strong> — Вклад в развитие отрасли</strong> – вклад в повышение прозрачности и безопасности финансовых операций, развитие инвестиционного климата.
                  <br />
                  <strong> — Социальная ответственность</strong> – наличие программ, направленных на финансовую грамотность, устойчивое развитие и улучшение социальной среды.
                  <br />
                  <strong> — Операционная эффективность</strong> – успешное снижение издержек, управление рисками и оптимизация финансовых процессов.
                  </div> 
                </div>

                <div class="t-col t-col_8 t-prefix_2">
                    <div class="t120__title t-heading t-heading_sm" field="title">Строительство и девелопмент</div>
                </div>


                <div class="t-col t-col_8 t-prefix_2"> 
                  <div field="text" class="t-text t-text_md ">
                 <strong> — Эстетическое и функциональное качество проектов</strong> – дизайн, архитектурные решения, которые учитывают современные стандарты и улучшение городской среды.
                  <br />
                  <strong> — Экономическое влияние</strong> – влияние на развитие местной экономики, создание рабочих мест, увеличение налоговых поступлений.
                  <br />
                  <strong> — Инновационные технологии и экологичность</strong> – внедрение экологичных технологий и материалов, энергоэффективность проектов.
                  <br />
                  <strong> — Социальная значимость</strong> – проекты, которые способствуют улучшению качества жизни, создают социальную инфраструктуру (школы, парки и т.д.).
                  <br />
                  <strong> — Эффективное управление проектами</strong> – соблюдение сроков, бюджета и других обязательств перед клиентами и государством.
                  </div> 
                </div>

                <div class="t-col t-col_8 t-prefix_2">
    <div class="t120__title t-heading t-heading_sm" field="title">Ритейл и торговля</div>
</div>

<div class="t-col t-col_8 t-prefix_2"> 
  <div field="text" class="t-text t-text_md ">
    <strong>— Инновационные решения в клиентском сервисе</strong> – использование новых технологий и подходов для повышения качества обслуживания клиентов.
    <br />
    <strong>— Управление ассортиментом и качеством продукции</strong> – разнообразие и адаптация ассортимента, гарантии качества, актуальность товаров.
    <br />
    <strong>— Эффективность и экономические результаты</strong> – рост прибыли, оптимизация затрат, устойчивость к рыночным изменениям.
    <br />
    <strong>— Клиентоориентированность</strong> – наличие программ лояльности, отзывчивое обслуживание и высокие стандарты поддержки клиентов.
    <br />
    <strong>— Вклад в развитие отрасли</strong> – развитие новых каналов сбыта, создание рабочих мест, улучшение стандартов обслуживания.
  </div> 
</div>


<div class="t-col t-col_8 t-prefix_2">
    <div class="t120__title t-heading t-heading_sm" field="title">Туризм и гостеприимство</div>
</div>

<div class="t-col t-col_8 t-prefix_2"> 
  <div field="text" class="t-text t-text_md ">
    <strong>— Качество и уникальность сервиса</strong> – внедрение сервисов, которые улучшают клиентский опыт и удовлетворяют потребности гостей.
    <br />
    <strong>— Развитие инфраструктуры и удобства</strong> – влияние на развитие туристической инфраструктуры и создание условий для комфортного отдыха.
    <br />
    <strong>— Инновации в управлении и обслуживании</strong> – использование цифровых технологий, систем управления бронированием, клиентского опыта.
    <br />
    <strong>— Вклад в местную экономику и культуру</strong> – создание рабочих мест, поддержка местных традиций и культурного наследия.
    <br />
    <strong>— Экологичность и устойчивость</strong> – соблюдение экологических стандартов, снижение воздействия на окружающую среду.
  </div> 
</div>


<div class="t-col t-col_8 t-prefix_2">
    <div class="t120__title t-heading t-heading_sm" field="title">Маркетинг и коммуникации</div>
</div>

<div class="t-col t-col_8 t-prefix_2"> 
  <div field="text" class="t-text t-text_md ">
    <strong>— Стратегическая эффективность и результативность</strong> – наличие четкой маркетинговой стратегии, достижение измеримых KPI, рост продаж, доли рынка, узнаваемости и лояльности.
    <br />
    <strong>— Инновационные технологии и подходы</strong> – внедрение передовых маркетинговых методов и MarTech-инструментов, автоматизация, аналитика, персонализация, новые форматы коммуникаций и каналов.
    <br />
    <strong>— Влияние на развитие отрасли</strong> – вклад в повышение профессиональных стандартов маркетинга, внедрение лучших практик, создание методологий, кейсов и решений, которые могут быть масштабированы другими участниками рынка.
    <br />
    <strong>— Социальная и этическая ответственность</strong> – соблюдение принципов прозрачной коммуникации, ответственное использование данных и персонализации, инициативы в области общественно значимых проектов, формирование доверия аудитории.
    <br />
    <strong>— Экономические результаты</strong> – доказанная финансовая эффективность маркетинговых решений: рост выручки и прибыли, оптимизация бюджетов, снижение CAC/CPA, повышение ROMI/ROI и долгосрочная коммерческая устойчивость проектов.
  </div> 
</div>


<div class="t-col t-col_8 t-prefix_2">
    <div class="t120__title t-heading t-heading_sm" field="title">Транспорт и логистика</div>
</div>

<div class="t-col t-col_8 t-prefix_2"> 
  <div field="text" class="t-text t-text_md ">
    <strong>— Оптимизация логистических процессов</strong> – внедрение технологий, повышающих эффективность и надежность логистики и транспортировки.
    <br />
    <strong>— Экологическая устойчивость</strong> – использование экологичных видов транспорта, снижение выбросов и энергоэффективность.
    <br />
    <strong>— Эффективность и экономические показатели</strong> – снижение затрат на транспортировку, повышение скорости и качества поставок.
    <br />
    <strong>— Влияние на региональную и международную логистику</strong> – успешная реализация крупных проектов, влияющих на логистическую инфраструктуру.
    <br />
    <strong>— Инновации в управлении и планировании</strong> – использование цифровых технологий и автоматизации для управления цепочками поставок.
  </div> 
</div>


<div class="t-col t-col_8 t-prefix_2">
    <div class="t120__title t-heading t-heading_sm" field="title">Инновации и технологии</div>
</div>

<div class="t-col t-col_8 t-prefix_2"> 
  <div field="text" class="t-text t-text_md ">
    <strong>— Уникальность и новизна решений</strong> – разработка и внедрение передовых технологий, которые изменяют подходы в отрасли.
    <br />
    <strong>— Экономическая выгода и эффективность</strong> – рост прибыли, снижение затрат за счет внедрения инновационных технологий.
    <br />
    <strong>— Применимость и масштабируемость</strong> – возможность масштабирования технологии, ее использование в разных отраслях и регионах.
    <br />
    <strong>— Влияние на развитие отрасли</strong> – положительное влияние на стандарты и конкурентоспособность отрасли.
    <br />
    <strong>— Экологическая и социальная ответственность</strong> – устойчивость технологий, их вклад в экологичность производства и устойчивое развитие.
  </div> 
</div>


<div class="t-col t-col_8 t-prefix_2">
    <div class="t120__title t-heading t-heading_sm" field="title">Ресторанный бизне</div>
</div>

<div class="t-col t-col_8 t-prefix_2"> 
  <div field="text" class="t-text t-text_md ">
    <strong>— Качество концепции и клиентского опыта</strong> – уровень проработки ресторанной концепции, стабильность сервиса, качество продукта, атмосферы и общего гостевого опыта.
    <br />
    <strong>— Операционная эффективность и управляемость</strong> – эффективность внутренних процессов, управление затратами, качеством, скоростью обслуживания, запасами, персоналом и стандартами работы.
    <br />
    <strong>— Инновации и развитие формата</strong> – внедрение новых технологических, управленческих, маркетинговых или гастрономических решений, повышающих конкурентоспособность бизнеса.
    <br />
    <strong>— Масштабирование и устойчивость бизнеса</strong> – способность развивать ресторанный проект или сеть без потери качества, наличие устойчивой бизнес-модели, рост выручки и операционной стабильности.
    <br />
    <strong>— Влияние на отрасль и социальная ответственность</strong> – вклад в развитие ресторанной индустрии, формирование новых практик, участие в профессиональном сообществе, соблюдение принципов качества, безопасности и ответственного ведения бизнеса.
  </div> 
</div>


<div class="t-col t-col_8 t-prefix_2">
    <div class="t120__title t-heading t-heading_sm" field="title">Спорт и активный образ жизни</div>
</div>

<div class="t-col t-col_8 t-prefix_2"> 
  <div field="text" class="t-text t-text_md ">
    <strong>— Популяризация здорового образа жизни</strong> – вклад в развитие массового спорта, улучшение доступности спортивных мероприятий для населения.
    <br />
    <strong>— Инновации и качество услуг</strong> – использование передовых методов и технологий для улучшения спортивных услуг и тренировок.
    <br />
    <strong>— Социальное влияние и вовлеченность</strong> – проекты, которые поддерживают массовое участие и формируют положительные социальные изменения.
    <br />
    <strong>— Экономическое влияние</strong> – создание рабочих мест, развитие спортивной инфраструктуры, вклад в локальную экономику.
    <br />
    <strong>— Устойчивое развитие и экологичность</strong> – учет экологических стандартов в проектах, устойчивость спортивных объектов и их позитивное воздействие на окружающую среду.
  </div> 
</div>


<div class="t-col t-col_8 t-prefix_2">
    <div class="t120__title t-heading t-heading_sm" field="title">Психология и личностное развитие</div>
</div>

<div class="t-col t-col_8 t-prefix_2"> 
  <div field="text" class="t-text t-text_md">
    <strong>— Влияние на эмоциональное благополучие</strong> – степень положительного воздействия на психическое здоровье и эмоциональное состояние людей.
    <br />
    <strong>— Инновации и качество методик</strong> – использование научных и современных подходов, результативность методик.
    <br />
    <strong>— Доступность и охват аудитории</strong> – возможность участия широких слоев населения, региональное или международное распространение программы.
    <br />
    <strong>— Социальная значимость</strong> – вклад в поддержку личностного роста и социальной устойчивости, вовлеченность в общественные проекты.
    <br />
    <strong>— Долгосрочные результаты</strong> – подтвержденное позитивное влияние на развитие навыков, устойчивые изменения в жизни участников.
  </div> 
</div>

<div class="t-col t-col_8 t-prefix_2">
    <div class="t120__title t-heading t-heading_sm" field="title">Мода и стиль</div>
</div>

<div class="t-col t-col_8 t-prefix_2"> 
  <div field="text" class="t-text t-text_md pb-150">
    <strong>— Инновационность дизайна и материалов</strong> – использование передовых технологий, уникальных тканей и новых подходов в создании одежды и аксессуаров.
    <br />
    <strong>— Экологичность и устойчивое производство</strong> – применение переработанных и органических материалов, снижение вредного воздействия на окружающую среду, отказ от быстрой моды.
    <br />
    <strong>— Влияние на индустрию</strong> – формирование новых трендов, развитие локального производства, продвижение осознанного потребления.
    <br />
    <strong>— Социальная ответственность</strong> – поддержка инклюзивности, создание доступной моды, участие в благотворительных и социальных инициативах
    <br />
    <strong>— Коммерческая успешность</strong> – устойчивость бизнес-модели, рост продаж, востребованность бренда и его влияние на рынок.
  </div> 
</div>
            </div>
        </div>
    </div>
    </>
  
  );
};

export default Creteria;
